import { isStaging } from '@/helpers/environment'
import { defaultPrices, ceoPrices } from './prices'
import { defaultSteps } from './steps/default'
import { ceoSteps } from './steps/ceo'

export const defaultFlow = Object.freeze({
  name: 'default',
  discounts: {
    default: isStaging ? 'dsc_01jc5e8ck055ygcbc2g4zm17ad' : 'dsc_01k1g1ymxppamkqdezpfyggawy',
    special: isStaging ? 'dsc_01jp2njm7f4y57jyntw5p7m4xk' : 'dsc_01k1g1z1th3y1r9ba3d59he4jg'
  },
  prices: defaultPrices,
  steps: defaultSteps,
  currency: 'USD'
})

export const ceoFlow = Object.freeze({
  name: 'ceo',
  discounts: {
    default: isStaging ? 'dsc_01jc5e8ck055ygcbc2g4zm17ad' : 'dsc_01k1g1ymxppamkqdezpfyggawy',
    special: isStaging ? 'dsc_01jp2njm7f4y57jyntw5p7m4xk' : 'dsc_01k1g1z1th3y1r9ba3d59he4jg'
  },
  prices: ceoPrices,
  steps: ceoSteps,
  currency: 'USD'
})
